<template>
    <b-container class="bv-example-row">
        <div v-show="stackview == 'main'">
            <!--            <b-row class="my-1 justify-content-md-center">-->
            <!--                <b-col sm="10">-->
            <!--                    <h3>Informações de ativação de usuário</h3>-->
            <!--                </b-col>-->
            <!--            </b-row>-->
            <!--            <hr>-->
            <!--            <ValidationObserver ref="formmain1" v-slot="{ passes }">-->
            <ValidationObserver ref="formmain_1" v-slot="{ invalid }">
                <b-form>
                    <b-row class="my-1 justify-content-md-center">
                        <b-col sm="9">
                            <!--                            <fieldset-->
                            <!--                                    style="border: 1px dotted #a2aab2;padding-left: 8px;margin-bottom: 12px;padding-bottom: 6px;">-->
                            <!--                                <legend style="text-align: left;width: fit-content;font-size: 14px;font-weight:bold;margin-left: 6px;opacity: 0.5;">-->
                            <!--                                    [ Observação ]-->
                            <!--                                </legend>-->
                            <!--                                <div style="text-align: justify-all;">-->
                            <!--                                    Caso não tenha um CNPJ para efetuar o cadastro, favor entrar em contato pelo-->
                            <!--                                    telefone (41) 9.9999-9999 no horário das 9:00 as 16:30 ou pelo e-mail-->
                            <!--                                    cursos@secovi.com.br.-->
                            <!--                                </div>-->
                            <!--                            </fieldset>-->
                            <ValidationProvider rules="required|min:18|max:18|cnpj" name="CNPJ empresa"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-cnpj">CNPJ empresa</label>
                                <b-input
                                        required
                                        placeholder="Entre com o CNPJ"
                                        v-model="ItemAtual.cnpj"
                                        v-mask="['##.###.###/####-##']"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-cnpj"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="my-1 justify-content-md-center">
                        <b-col sm="9">
                            <ValidationProvider rules="required|min:14|max:14|cpf" name="CPF Associado"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-CPF">CPF Associado</label>
                                <b-input
                                        required
                                        placeholder="Entre com o CPF do associado!"
                                        v-model="ItemAtual.CPF"
                                        v-mask="['###.###.###-##']"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-CPF"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="my-1 justify-content-md-center mt-5 mr-2">
                        <b-col sm="10">
                            &nbsp;
                        </b-col>
                        <b-col sm="2">
                            <b-button variant="primary" @click="validarCnpj" :disabled="invalid">Validar</b-button>
                        </b-col>
                    </b-row>
                </b-form>

            </ValidationObserver>
        </div>
        <div v-show="stackview == 'cnpjinvalido'">
            <p>CNPJ sem acesso ou com restrição! Entre em contato com o Administrador do Sistema</p>
            <b-button variant="primary" @click="stackview='main'">Voltar</b-button>
            <!--            <lista-users-wordpress></lista-users-wordpress>-->
        </div>
        <div v-show="stackview == 'cadastro'">
            <cadastro-users-word-press-c
                    ref="cadNovo"
                    :data="ItemAtual"
                    :cnpj="ItemAtual.cnpj"
                    :cpf="ItemAtual.CPF"
                    :razao="ItemAtual.razao"
                    :idempresa="ItemAtual.idempresa"
                    @finalizado="stackview='Fim'"
            ></cadastro-users-word-press-c>
        </div>
        <div v-show="stackview == 'cpfcadastrado'">
            <!--            CPF Já existente!-->
            <wordpressauth ref="wpauth"
                           :cpf="ItemAtual.CPF"
                           v-model="ItemAtual.CPF"
                           @finalizado="loginOk"
            ></wordpressauth>
        </div>
        <div v-show="stackview == 'datareview'">
            <cadastro-users-word-press-b
                    ref="cadReview"
                    :data="dt"
                    :cnpj="ItemAtual.cnpj"
                    :cpf="ItemAtual.CPF"
                    :razao="ItemAtual.razao"
                    :idempresa="ItemAtual.idempresa"
                    @finalizado="stackview='Fim'"
            ></cadastro-users-word-press-b>
        </div>
        <div v-show="stackview == 'Fim'">
            <h3>Cadastro efetuado com sucesso!</h3><br>
            <hr>
            Para efetuar o seu primeiro acesso <a :href="`https://habitacao.secoviunihab.com.br/wp-login.php`">clique aqui</a>!<br>
            Recomendamos guardar no favoritos a pagina de login ao acessar a primeira vez!
            <hr>

        </div>

        <div v-show="stackview == 'mercadoescolha'">
            <ValidationObserver ref="formChoice" v-slot="{ invalid }">
                <b-form>
                    <fieldset style="border: 1px dotted #a0a0a0;margin-top:40px;">
                        <legend style="font-size: 15px;font-weight:bold;margin-left:6px;opacity: 0.4;width: fit-content;">
                            [ Escolha do mercado ]
                        </legend>
                        <b-row>
                            <b-col sm="2"></b-col>
                            <b-col sm="10">
                                <ValidationProvider rules="required"
                                                    name="Escolha de mercado"
                                                    v-slot="{ valid, errors }">
                                    <b-form-group label="Você é do mercado:" class="ma-8">
                                        <b-form-radio v-model="ItemAtual.mercadoescolha"
                                                      name="some-radios"
                                                      value="condominial"
                                                      required
                                                      class="pl-5">
                                            Condominial
                                        </b-form-radio>
                                        <b-form-radio v-model="ItemAtual.mercadoescolha"
                                                      required
                                                      name="some-radios"
                                                      value="imobiliario"
                                                      class="pl-5">
                                            Imobiliário
                                        </b-form-radio>
                                    </b-form-group>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
<!--                                <div class="mt-3">Selected: <strong>{{ site_url }} {{ ItemAtual.mercadoescolha-->
<!--                                    }}</strong></div>-->
                            </b-col>
                        </b-row>
                        <b-row class="my-1 justify-content-md-center mt-5 mr-2 mb-5 pb-5 pt-5"
                               style="">
                            <b-col sm="10">
                                &nbsp;&nbsp;
                                <!--                            idempresa:{{idempresa}}-->
                                <!--                            razao:{{razao}}-->
                                <!--                            <pre>-->
                                <!--                            {{ItemAtual2}}-->
                                <!--                            </pre>-->
                                <span v-show="invalid" style="color: red;font-weight: bold;margin-left: 5px;">
                                Favor fazer uma escolha para continuar o processo!
                            </span>
                                <span v-show="!invalid" style="color: blue;font-weight: bold;margin-left: 5px;">
                                Pronto para enviar!
                            </span>

                            </b-col>
                            <b-col sm="2">
                                <b-button :variant="invalid?'secondary':'primary'" @click="stackview = 'main'"
                                          :disabled="invalid">
                                    Enviar
                                </b-button>
                            </b-col>
                        </b-row>
                    </fieldset>
                </b-form>
            </ValidationObserver>
        </div>
    </b-container>
</template>

<script>
    //https://vuejs-tips.github.io/vue-the-mask/
    import { ValidationObserver, ValidationProvider } from "vee-validate";
    // import CadastroUsuario                            from "./cadastroUsuario";
    // import FormTeste                                  from "./formTeste";
    import CadastroUsersWordPressB                    from "./CadastroUsersWordPressB";
    import CadastroUsersWordPressC                    from "./CadastroUsersWordPressC";
    import Wordpressauth                              from "./wordpressauth";

    function sleep (ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    export default {
        name      : "VerificaCnpjB",
        components: {
            Wordpressauth,
            CadastroUsersWordPressB,
            CadastroUsersWordPressC,
            ValidationObserver,
            ValidationProvider
        },
        data () {
            return {
                // passes   : false,
                // stackview: 'mercadoescolha',
                stackview: 'main',
                // stackview: 'Fim',
                // site_url : `${window.tirech_AppConfig.base_wp}/wp-login.php`,
                // site_url2: window.site_url,
                ItemAtual: {
                    code          : this.decodeCNPJ(),
                    cnpj          : '',//'78.376.472/0001-30',
                    CPF           : '',//'969.882.530-41',
                    idempresa     : -1,
                    razao         : '',
                    mercadoescolha: ''
                },
                dt       : []
            }
        },
        // computed  : {
        //     validation () {
        //         return this.ItemAtual.cnpj.length > 10 && this.ItemAtual.cnpj.length < 30
        //     }
        // },
        computed  : {
            site_url () {
                let m  = this,
                    lt = window.tirech_AppConfig.base_wp
                ;
                if (m.ItemAtual.mercadoescolha == 'condominial') {
                    lt = lt.replace('habitacao',m.ItemAtual.mercadoescolha);
                    return `${lt}/`;
                }
                else {
                    lt = lt.replace('habitacao',m.ItemAtual.mercadoescolha);
                    return `${lt}/`;
                }
            }
        },
        methods   : {
            decodeCNPJ () {
                try {
                    return JSON.parse(sessionStorage.getItem('code'))
                } catch (e) {}
                finally {
                    return []
                }
            },
            loginOk (data) {
                let m = this;
                console.log('Login Ok', data);
                this.stackview = 'datareview';
                data.mercadoescolha = m.ItemAtual.mercadoescolha;
                this.ItemAtual.mercadoescolha = m.ItemAtual.mercadoescolha;
                let dt = {
                    mercadoescolha: m.ItemAtual.mercadoescolha,
                    ...data,
                    ...this.ItemAtual
                };
                dt.data.mercadoescolha = m.ItemAtual.mercadoescolha;
                dt.ItemAtual = m.ItemAtual.mercadoescolha;
                m.dt = dt;

                m.$refs.cadReview.loadDataReview(dt)
            },
            async seguirParaCadastro (m) {
                await sleep(10);
                console.log('seguirParaCadastro', m.ItemAtual);
                m.dt.mercadoescolha = m.ItemAtual.mercadoescolha;
                let dt = {
                    mercadoescolha: m.ItemAtual.mercadoescolha,
                    ...m.dt,
                    ...m.ItemAtual
                };
                dt.data = m.ItemAtual.mercadoescolha;

                m.$refs.cadNovo.loadDataReview(dt);

                if (!!m.ItemAtual.CPF && !!m.ItemAtual.cnpj) {
                    m.stackview = 'cadastro';
                }
            },
            validarCnpj () {
                console.log("validarCnpj", this.ItemAtual);

                let m = this;
                //https://logaretm.github.io/vee-validate/guide/forms.html#programmatic-access-with-refs
                m.$refs.formmain_1.validate().then(success => {
                    try {
                        axios({
                                  method      : 'get',
                                  // url         : '/getValidarCnpj.php',
                                  responseType: 'json',
                                  params      : {
                                      op  : 'consultaCNPJ',
                                      cpf : m.ItemAtual.CPF,
                                      cnpj: m.ItemAtual.cnpj
                                  }
                              })
                            .then(function (response) {
                                // m.dt = response.data;
                                if (response.data.data.cnpjvalid) {
                                    // debugger;
                                    m.ItemAtual.razao = response.data.data['RAZAO'];
                                    m.ItemAtual.idempresa = response.data.data['IDCODIGO'];
                                    m.dt = response.data;
                                    m.dt.mercadoescolha = m.ItemAtual.mercadoescolha;
                                    //se usuário não existe ir para cadastro
                                    if (response.data.data.cpfvalid) {
                                        console.log('nexttick.created');
                                        m.$nextTick(() => {
                                            m.seguirParaCadastro(m);
                                        });
                                    }
                                    else {
                                        //usuário já existente! mostrar mensagem!
                                        m.stackview = 'cpfcadastrado';
                                    }
                                }
                                else {
                                    m.stackview = 'cnpjinvalido';
                                }
                            });
                    } catch (e) { }
                    finally { }
                });
            }
        },
        created () {},
        mounted () {}
    }
</script>

<style scoped>

</style>
